














import BaseState from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/BaseState.vue'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
@Component({
  components: { BaseState },
})
export default class ErrorState extends Vue {
}
